function MainContent({ cssClasses = '', children, id }) {
  return (
    <main className={`main-content ${cssClasses}`} id={id}>
      {children}
    </main>
  );
}

export default MainContent;
